import {Photo} from "../hooks/useGalleryPhotos";
import PhotoAlbum from "react-photo-album";
import config from "../../../../config";

import styles from "./detail.module.css"
import move from "./Move/move.module.css"
import cx from "clsx";
import PhotoButtons from "./PhotoButtons";
import {Box} from "@mantine/core";
import {IconCheck} from "@tabler/icons-react";
import {timeToString} from "../../../../utils/dateToString";

interface Props {
  photos: Photo[]
  slug: string
  galleryId: number | null
  selectMode?: boolean
  selectedPhotos?: Set<number>
  onTogglePhoto?: (id: number) => void
}

const PhotoAlbumView = (props: Props) => {
  const photos = props.photos.map(photo => ({
    width: photo.width || 500,
    height: photo.height || 500,
    src: `${config.apiURL}/photos/${props.slug}/${photo.path}/300`,
    href: photo.id
  }))

  const getPhoto = (href: number) => {
    return props.photos.find(photo => photo.id === href)
  }

  return (
    <Box mt="md" mb="md">
      <PhotoAlbum layout="rows" photos={photos}
                  renderPhoto={({imageProps: {src, alt, style, ...restImageProps}, photo}) => {
                    const selected = !!props.selectedPhotos?.has(photo.href)
                    if (props.selectMode) {
                      const photoTime = Date.parse(getPhoto(photo.href)?.sort_time ?? "")
                      return (
                        <div className={cx(styles.photoWrapper, move.selectable)} style={style}
                             onClick={() => props.onTogglePhoto?.(photo.href)}>
                          <div className={cx(move.selectableBox, selected && move.selected)}>
                            <img src={src} alt={alt}
                                 style={{height: "100%", width: "100%", objectFit: "cover", backgroundColor: "#dee2e6"}}
                                 {...restImageProps} loading="lazy"/>
                            <div className={cx(move.check, !selected && move.checkEmpty)}>
                              {selected ? <IconCheck size={16}/> : null}
                            </div>
                            {!isNaN(photoTime) ? (
                              <div className={move.time}>{timeToString(photoTime)}</div>
                            ) : null}
                          </div>
                        </div>
                      )
                    }
                    return (
                      <div className={styles.photoWrapper} style={style}>
                        <img src={src} alt={alt} style={{height: "100%", width: "100%", backgroundColor: "#dee2e6"}} {...restImageProps}
                             loading="lazy"/>
                        <div className={styles.absolute}>
                          <PhotoButtons galleryId={props.galleryId} slug={props.slug} photo={getPhoto(photo.href)}/>
                        </div>
                      </div>
                    )
                  }}
      />
    </Box>
  )
}

export default PhotoAlbumView
